import React, { Component } from 'react'
class EditTitleForm extends Component {

    constructor(props) {
        super()
        this.state = {
            title: props.title
        }
    }

    componentDidMount() {
        this.setFocus()
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        this.props.clearFormErrors()
        document.removeEventListener('mousedown', this.handleClickOutside);
    }


    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.props.cancel(event);
        }
    }

    setFocus() {
        let input = document.getElementById("naming-container");
        input.focus();
    }

    renderErrors = (error) => {
        return (
            <ul className="flex-centered shake-on-error" id="form-errors">
                {error}
            </ul>
        );
    }

    handleChange = (e) => {
        if (this.props.errors.length > 0) {
            this.props.clearFormErrors()
        }
        this.setState({ title: e.target.value })
    }

    handleSubmit = async (e) => {
        e.preventDefault()
        if (!this.state.title) {
            return this.props.submitFormError("Work Instruction Titles Cannot Be Blank")
        }

        if (this.props.title === this.state.title) {
            this.props.cancel()
        }

        if (this.props.originalTitle === this.state.title) {
            this.props.submitTitleEdit(this.state.title)
        } else {
            let isAvailable = await this.props.checkNameAvailability(this.state.title)
            if (isAvailable) {
                this.props.submitTitleEdit(this.state.title)
            } else {
                this.props.submitFormError("That Work Instruction Title is Unavailable")
            }
        }

    }

    render() {
        return <form onSubmit={this.handleSubmit} id="edit-title-form" className="flex" ref={this.wrapperRef}>
            <input
                id="naming-container"
                type="text"
                placeholder="Title Your Work Instruction"
                value={this.state.title}
                onChange={this.handleChange}
                style={{height:"25px"}}
            />
            {this.props.errors.length > 0 ? this.renderErrors(this.props.errors) : null}
            {/* <div id="new-step-action-buttons">
                <span style={{ background: "lightgrey" }} onClick={(event) => this.props.cancel(event)}>Cancel</span>
                <input type="submit" value="Submit" style={{ background: "#3d7ce2", color: "white" }}></input>
            </div> */}
        </form> 
    }
}

export default EditTitleForm